<template>
  <div id="dashboard-dividends">
    <v-card
      class="px-5 py-2 mt-4 mb-0 elevation-0"
      :class="{ 'sticky-filters': user.preferences.stickyFilters }"
    >
      <CommonFilters type="dividend" section="dashboard" @filterElements="filterElements" />
    </v-card>

    <v-row>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <DividendsByMonth ref="dividendsByMonth" />
      </v-col>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <DividendsByPosition ref="dividendsByPosition" />
      </v-col>

      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersByMonth ref="scripByMonth" type="scrip" />
      </v-col>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersByPosition ref="scripByPosition" type="scrip" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CommonFilters from '@/views/components/common/CommonFilters'
import DividendsByPosition from '@/views/components/dashboardDetail/dividends/DividendsByPosition.vue'
import DividendsByMonth from '@/views/components/dashboardDetail/dividends/DividendsByMonth.vue'
import OrdersByPosition from '@/views/components/dashboardDetail/orders/OrdersByPosition'
import OrdersByMonth from '@/views/components/dashboardDetail/orders/OrdersByMonth.vue'

export default {
  components: {
    CommonFilters,
    DividendsByPosition,
    DividendsByMonth,
    OrdersByPosition,
    OrdersByMonth,
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    async filterElements(filters) {
      this.loading = true
      try {
        if (this.$refs.dividendsByPosition) this.$refs.dividendsByPosition.loadSummary(filters)
        if (this.$refs.dividendsByMonth) this.$refs.dividendsByMonth.loadSummary(filters)

        if (this.$refs.scripByPosition) this.$refs.scripByPosition.loadSummary(filters)
        if (this.$refs.scripByMonth) this.$refs.scripByMonth.loadSummary(filters)
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }
      this.loading = false
    },
  },
}
</script>
